export default __webpack_public_path__ + "static/media/family-term-life.77ef27b4.jpg";